import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import App from "./App";
import {CssBaseline, CssVarsProvider, extendTheme} from "@mui/joy";

const theme = extendTheme({
    colorSchemeSelector: 'media',
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <CssVarsProvider theme={theme}>
        <CssBaseline />

        <React.StrictMode>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <Routes path="/">
                    <Route index element={<App />} />
                    <Route path='*' element={<>404</>} />
                </Routes>
            </BrowserRouter>
        </React.StrictMode>
    </CssVarsProvider>
);
